/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:29
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-30 13:38:04
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\base\mutations.js
 */
import * as MUTATIONTYPES from '../mutationTypes'
import * as STATETYPES from '../stateTypes'
import locals from '@/local'
const mutations = {
	[MUTATIONTYPES.SETRESEARCHRAUTHORITY](state, data) {
		state[STATETYPES.RESEARCHRAUTHORITY] = data
	},
	[MUTATIONTYPES.SETIDENTITYTYPE](state, data) {
		locals.setIdentityType(data)
		state[STATETYPES.IDENTITYTYPE] = data
	}
}
export default mutations